import type { PullToRefreshStatus } from 'common/hooks/pull-to-refresh/pull-to-refresh.business';
import { PULL_THRESHOLD_PX } from 'common/hooks/pull-to-refresh/pull-to-refresh.constants';
import {
  HIDDEN_OFFSET_PX,
  MAX_ICON_ROTATION_DEG,
  RESTING_OFFSET_PX,
} from './pull-to-refresh-indicator.constants';

export const toIndicatorOffset = (pullDistance: number, status: PullToRefreshStatus): number =>
  status === 'refreshing' || status === 'failed'
    ? RESTING_OFFSET_PX
    : HIDDEN_OFFSET_PX + pullDistance;

export const toIconRotation = (pullDistance: number): number =>
  Math.min(1, pullDistance / PULL_THRESHOLD_PX) * MAX_ICON_ROTATION_DEG;
